import React from 'react';
import { Route, Switch } from "react-router-dom";
import CheckerReportsModule from "./rr-checker-reports-module/checker-reports-module";

const RRCheckerReports = () => {
  return (
    <Switch>
      <Route exact path="/checker_reports">
        <CheckerReportsModule />
      </Route>
    </Switch>
  )
}

export default RRCheckerReports;



